export default __webpack_public_path__ + "static/media/schedule-watermark.2ffe6802.png";